import { render, staticRenderFns } from "./ChangeOfStatusSignedApproval.vue?vue&type=template&id=2b6b5cb6&scoped=true"
import script from "./ChangeOfStatusSignedApproval.vue?vue&type=script&lang=js"
export * from "./ChangeOfStatusSignedApproval.vue?vue&type=script&lang=js"
import style0 from "./ChangeOfStatusSignedApproval.vue?vue&type=style&index=0&id=2b6b5cb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6b5cb6",
  null
  
)

export default component.exports